export default {"src":"/_next/static/media/calendar_insurance.f95c6e5d.svg","height":50,"width":63,"blurWidth":0,"blurHeight":0};